import { Menubar } from "primereact/menubar";
import "primeicons/primeicons.css";
import React, { useEffect, useRef, useState } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { MenuItem } from "primereact/menuitem";
import { useNavigate } from "react-router-dom";
import FormDirtyListener from "../formListener/FormDirtyListener";
import { LeaveDialog } from "../form/components/leavePage/LeavePageWarning";
import { Role } from "../../shared/enums/Role";

export function Header() {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [navigatePath, setNavigatePath] = useState("");
  const [isDirty, setIsDirty] = useState(false);
  const isDirtyRef = useRef(isDirty);
  const role = account !== undefined && account?.idTokenClaims !== undefined && account?.idTokenClaims["extension_Roles"];
  const Logout = async () => {
    try {
      await instance.logoutRedirect();
    } catch (error) {
      console.error(error);
    }
  };

  function getMenu(): ExtendedMenuItem {
    switch (role) {
      case Role.assessor:
      case Role.manager:
      case Role.root: {
        return adminMenu(getCommand);
      }
      case Role.provider: {
        return providerMenu(getCommand);
      }
      case Role.kindergarten: {
        return kindergartenMenu(getCommand);
      }
    }
    return {};
  }

  const [items, setItems] = useState<ExtendedMenuItem[]>([
    {
      label: "Home",
      command: () => {
        getCommand("/home");
      },
    },
    getMenu(),

    {
      label: "KIS Providers",
      command: () => {
        getCommand("/providers");
      },
      roles: [Role.manager, Role.assessor],
    },
    {
      label: "Reference Data Management",
      command: () => {
        getCommand("/referenceDataManagement");
      },
      roles: [Role.manager],
    },
    {
      label: account?.name,
    },
    {
      label: "Logout",
      command: () => {
        Logout();
      },
    },
  ]);

  function getCommand(path: string) {
    if (isDirtyRef.current) {
      setShowDialog(true);
      setNavigatePath(path);
      return;
    } else {
      navigate(path);
    }
  }

  useEffect(() => {
    let newItems = [...items];
    const role = account != undefined && account?.idTokenClaims != undefined && account?.idTokenClaims["extension_Roles"];

    newItems = newItems.filter((i) => i.roles == null || i.roles.length === 0 || i.roles.includes(role as Role));
    newItems.forEach((i: any) => {
      isActive(i);
    });
    setItems(newItems);
  }, [location.pathname, account]);

  const isActive = (item: MenuItem) => {
    const route = location.pathname.split("/")[1];
    if (route === item.url?.replace(/\//g, "")) {
      item.className = "active-menu-item";
      return true;
    } else if (item.items != null && items.length > 0) {
      let subSelected = false;
      item.items.forEach((i: any) => {
        const isSelected = isActive(i);
        if (isSelected) {
          subSelected = true;
        }
      });
      if (subSelected) {
        item.className = "active-menu-item";
      }
    }
  };

  const handleLeavePage = () => {
    setIsDirty(false);
    isDirtyRef.current = false;
    setShowDialog(false);
    navigate(navigatePath);
  };

  const handleStay = () => {
    setShowDialog(false);
  };

  useEffect(() => {
    isDirtyRef.current = isDirty;
  }, [isDirty]);

  return (
    <>
      {" "}
      <FormDirtyListener onDirtyChange={setIsDirty} />
      <div className="main-nav">
        <div className="flex justify-content-left kis-logo">
          <div className="flex text-blue font-bold justify-content-start text-left align-items-center flex-row">
            <div className="flex mt-1">
              <div className="header">
                <div className="text-purple text-3xl flex align-center ">
                  {" "}
                  <span className="kis-icon-purple"></span>Kindergarten Inclusion <br />
                  Support
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
        <Menubar model={items} className="mr-3 ml-1 bg-none border-none user-name pl-0 flex justify-content-end drop-down dont-show-in-print" />
      </div>
      {showDialog && LeaveDialog(showDialog, handleStay, handleLeavePage)}
    </>
  );
}

interface ExtendedMenuItem extends MenuItem {
  roles?: Role[];
}

function adminMenu(getCommand: (path: string) => void): ExtendedMenuItem {
  return {
    label: "Applications",
    items: [
      {
        label: "Presubmission",
        command: () => {
          getCommand("/presubmission");
        },
      },
      {
        label: "My Applications",
        command: () => {
          getCommand("/myapplications");
        },
      },
      {
        label: "Applications",
        command: () => {
          getCommand("/applications");
        },
      },
      {
        label: "Assessments",
        command: () => {
          getCommand("/assessments");
        },
      },
      {
        label: "Finalised",
        command: () => {
          getCommand("/finalised");
        },
      },
    ],
  };
}

function providerMenu(getCommand: (path: string) => void): ExtendedMenuItem {
  return {
    label: "Applications",
    items: [
      {
        label: "Applications",
        command: () => {
          getCommand("/provider/applications");
        },
      },
    ],
  };
}

function kindergartenMenu(getCommand: (path: string) => void): ExtendedMenuItem {
  return {
    label: "Applications",
    items: [
      {
        label: "Applications",
        command: () => {
          getCommand("/kindergarten/submittedApplications");
        },
      },
      {
        label: "Applications Pending Submission",
        command: () => {
          getCommand("/kindergarten/pendingApplications");
        },
      },
    ],
  };
}
